import { useContext } from "react";
import { SummaryStateProps } from "./context/types";
import { SummaryContext } from "./SummaryNew";

const useSummaryState = (): SummaryStateProps => {
  const { state } = useContext(SummaryContext);

  return state;
};

export default useSummaryState;
